<script setup>
import { ref, computed, onMounted } from 'vue'
import { Bar, Line } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js'
import { useTheme } from '@/composables/theme'

ChartJS.register(Title, Tooltip, /* Legend, */ LineElement, PointElement, BarElement, CategoryScale, LinearScale);

const { isDark } = useTheme();

const props = defineProps({
  data: {
    type: Object,
    default: [ ]
  },
  color: {
    type: String,
    default: "rgb(29 78 216)"
  }
});

const chartData = computed(() => {
  if (props.data && props.data.length) {
    return {
      labels: props.data.map(p => p.x),
      datasets: [ {
        label: "Chart",
        //borderColor: '#ef4444',
        //backgroundColor: 'rgba(239, 68, 68, 0.1)',
        //backgroundColor: "rgb(28 100 242 / .2)", //"rgb(235 245 255)",
        //backgroundColor: isDark.value ? "rgb(219 234 254)" : "rgb(29 78 216)",
        backgroundColor: props.color,
        tension: 0.3,
        borderWidth: 0,
        fill: true,
        data: props.data.map(p => p.y)
      } ]
    };
  }
  else {
    return {
      labels: [ ],
      datasets: [ { data: [ ] } ]
    };
  }
});

const chartOptions = ref({
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      ticks: {
        display: false
      }
    },
    y: {
      ticks: {
        display: false
      }
    },
    yAxes: [{
        ticks: {
            display: false
        }
    }]
  }
  // scales: {
  //   x: { grid: { color: '#334155' }, ticks: { color: '#94a3b8' } },
  //   y: { min: 0, max: 100, grid: { color: '#334155' }, ticks: { color: '#94a3b8', stepSize: 20 } }
  // }
});
</script>

<template>
  <div>
    <Bar
      id="my-chart-id"
      :options="chartOptions"
      :data="chartData"
    />
  </div>
</template>

<style scoped>
</style>
